import getLocalUser from './../../helpers/auth';

const user = getLocalUser();
export default {
  state: {
    currentUser: user,
    isLoggedIn: !!user,
    auth_error: null
  },
  getters: {
    currentUser (state) {
      if (state.currentUser) {
        return state.currentUser;
      } else {
        return {};
      }
    },
    isLoggedIn (state) {
      return state.isLoggedIn;
    }
  },
  mutations: {
    login (state) {
      state.loading = true;
      state.auth_error = null;
    },
    loginSuccess (state, payload) {
      state.auth_error = null;
      state.isLoggedIn = true;
      state.loading = false;
      const token = payload.token_type + ' ' + payload.access_token;
      state.currentUser = Object.assign({}, payload.user, {
        token,
        id: payload.user_id,
        client_id: payload.client_id,
        name: payload.name,
        email: payload.email,
        is_admin: payload.is_admin,
        avatar: payload.avatar,
        color: payload.color,
        role: payload.role
      });
      localStorage.setItem('user', JSON.stringify(state.currentUser));
      window.axios.defaults.headers.common['Authorization'] = token;
    },
    loginFailed (state, payload) {
      state.loading = false;
      state.auth_error = payload.error;
    },
    logout (state) {
      localStorage.removeItem('user');
      state.isLoggedIn = false;
      state.currentUser = null;
      localStorage.removeItem('user');
    },
    redirectToDashboard (state) {
      this.$router.push('/survey');
    }
  },
  actions: {
    login (context) {
      context.commit('login');
    },
    logout (context) {
      context.commit('logout');
    },
    redirectToDashboard (context) {
      context.commit('redirectToDashboard');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/login.js